const variantClass = {
  neutral: 'aui-badge-neutral',
  success: 'aui-badge-success',
  warning: 'aui-badge-warning',
  danger: 'aui-badge-danger',
  info: 'aui-badge-info',
  sync: 'aui-badge-sync',
  secret: 'aui-badge-secret',
};

export default function Badge({ children, variant = 'neutral', className = '' }) {
  const cls = ['aui-badge', variantClass[variant] || variantClass.neutral, className].filter(Boolean).join(' ');
  return <span className={cls}>{children}</span>;
}
